import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { AppRouter } from './router';
import { ErrorBoundary } from './components/ErrorBoundary';

/**
 * App — root component.
 *
 * Provider hierarchy (outermost to innermost):
 * 1. BrowserRouter — React Router v6 history context
 * 2. AuthProvider — JWT parsing from cookie, role resolution
 * 3. ErrorBoundary — catches a render crash in any routed page (see its own doc comment); a sign-in
 *    is still valid underneath it, so it sits inside AuthProvider rather than replacing the whole tree.
 * 4. AppRouter — role-gated route definitions
 *
 * AuthProvider must be inside BrowserRouter so that:
 * - useNavigate() works inside AuthProvider (for redirect on token expiry in Phase 2)
 * - Route transitions triggered by auth state work correctly
 */
export default function App(): React.ReactElement {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <AppRouter />
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
}
